import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../components/icons";
import UserContext from "../context/user";
import { useNavigazione } from "../context/navigazione";
import { useCart } from "../hooks/useQueryCart";
import {
  // EARLYBIRD_MODE,
  ECOMMERCE_MODE,
  // ECOMMERCE_NO_PRENOTAIZONI_MODE,
} from "../utils/constants";

const UserMenu = () => {
  const [menuUserOpen, setMenuUserOpen] = useState(false);
  const { logout, isLogged } = useContext(UserContext);
  const { getPathByTemplate, mode } = useNavigazione();
  const linkCarrello = getPathByTemplate("carrello");
  const linkAreaClienti = getPathByTemplate("areaClienti");
  const linkprogramma = getPathByTemplate("programma");
  const ordiniLink = getPathByTemplate("ordini");

  const { data: cart } = useCart();

  return isLogged ? (
    <>
      <span className="btn-account position-relative  me-4">
        <button
          onClick={() => setMenuUserOpen(!menuUserOpen)}
          //onMouseOver={() => setMenuUserOpen(true)}
          title="Account"
          type="button"
        >
          <Icon name="user" />
          <Icon name="angle-down" className="small" />
        </button>
        {menuUserOpen && (
          <div
            className="shopping-menu"
            //onMouseLeave={() => setMenuUserOpen(false)}
          >
            <ul className="shopping-menu__list">
              <li className="shopping-menu__item shopping-menu__item--area-clienti">
                <Link
                  className="shopping-menu__link"
                  title="Biglietti e prenotazioni"
                  to={linkAreaClienti}
                >
                  Area clienti
                </Link>
              </li>
              {mode === ECOMMERCE_MODE && (
                <>
                  <li className="shopping-menu__item">
                    <Link className="shopping-menu__link" to={`${ordiniLink}`}>
                      I tuoi ordini
                    </Link>
                  </li>
                  <li className="shopping-menu__item">
                    <Link
                      className="shopping-menu__link"
                      to={`${linkprogramma}?fav=true`}
                    >
                      Eventi preferiti
                    </Link>
                  </li>
                </>
              )}
              <li className="shopping-menu__item">
                <Link className="shopping-menu__link" to="/profilo">
                  Il tuo profilo
                </Link>
              </li>
              <li className="shopping-menu__item">
                <button className="shopping-menu__link" onClick={logout}>
                  Esci
                </button>
              </li>
            </ul>
          </div>
        )}
      </span>
      {mode === ECOMMERCE_MODE && (
        <span className="btn-carrello me-4">
          <Link className="btn" title="Carrello" to={linkCarrello}>
            <Icon name="shopping-cart" />
            {cart?.prenotazioni_tot > 0 && (
              <span className="btn__book">{cart.prenotazioni_tot}</span>
            )}
          </Link>
        </span>
      )}
    </>
  ) : (
    <span className="btn-account me-4">
      <Link to={linkAreaClienti}>
        <Icon name="user" />
      </Link>
    </span>
  );
};

export default UserMenu;
